// Home
import Home from '../views/Home.vue'

// Integrations
import integrateEpic from '../views/Integrations/IntegrateEpic.vue'
import integrations from '../views/Integrations/Index.vue'
import epicAccountSearch from '../views/Integrations/EpicAccountSearch.vue'
import stats from "@/views/stats/Stats.vue";

// Error 404
import PageNotFound from '../views/404/Index.vue'
import integrateBP from "@/views/Integrations/IntegrateBP.vue";

const routes = [
  { path: '/', component: Home, name: 'Home' },
  { path: '/Integrations', component: integrations, name: 'Integrations' },
  { path: '/Integration/:integrationId/:din/EPIC', component: integrateEpic , name: 'IntegrateEpic' },
  { path: '/Integration/:integrationId/:din/BP', component: integrateBP , name: 'IntegrateBP' },
  { path: '/EpicAccountSearch', component: epicAccountSearch , name: 'EpicAccountSearch' },
  { path: '/Stats', component: stats, name: 'Stats'},
  { path: '*', component: PageNotFound }
]

export default routes;
